// /// <reference path="../../../../../node_modules/@angular/core/src/metadata/lifecycle_hooks.d.ts"/> //todo does it still work?
import { Component, forwardRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, Validator } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GbGemeindeSearchMode } from '../gb-gemeinde/gbGemeindeSearchMode';
import { GbGemeindeComponent } from '../gb-gemeinde/gb-gemeinde.component';
import { AvMutationsNummerRequestMeta } from '../../../core/av-api';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-av-mutations-nummer',
  templateUrl: './av-mutations-nummer.component.html',
  styleUrls: ['./av-mutations-nummer.component.scss'],
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => AvMutationsNummerComponent), multi: true },
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AvMutationsNummerComponent), multi: true }
  ],
  imports: [FormsModule, CapFormRowDirective, CapFormControlComponent, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class AvMutationsNummerComponent implements OnDestroy, ControlValueAccessor, Validator {
  @Input()
  searchMode: GbGemeindeSearchMode;

  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @ViewChild(GbGemeindeComponent, { static: true })
  private gemeindeComponent: GbGemeindeComponent;

  @Input() heading: string;

  @Input() nurGueltige = true;

  @Input() hasfocus = false;

  model: AvMutationsNummerRequestMeta = {};

  private _subscription: Subscription;

  onTouched: () => void;
  onValidatorChange: () => void;

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  writeValue(obj: any): void {
    this.model = obj;
  }

  registerOnChange(fn: any): void {
    this._subscription = this.form.control.valueChanges.subscribe(() => {
      // we can't pass the inner form's model because that model is derived from the form model
      // which does not know about, and therefore copy, properties not mapped with ngModel, such as our metas
      // to preserve the metas, we therefore pass our original model. Hopefully this never causes a problem ... (MOO)
      fn(this.model);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
    // TODO das formular fragen, wann der Event auftritt, damit wir nicht unser Template verunstalten muessen
  }

  public focus() {
    this.gemeindeComponent.focus();
  }

  validate(c: AbstractControl): {
    [key: string]: any;
  } | null {
    return this.form.valid ? null : { nestedErrors: true };
    // we can't return {} to signal nested errors in a semantically appropriate way
    // because mergeErrors helpfully ignores objects without keys :-(
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
